(function () {
  const wrap = document.querySelector('[data-contact-form]');
  if (!wrap) return;
  const form = wrap.closest('form');
  if (!form) return;

  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const BREADCRUMB_BASE = 'お問い合わせ';
  const BREADCRUMB_CONFIRM = 'お問い合わせ 入力内容確認';

  const fields = Array.from(wrap.querySelectorAll('[data-validate]'));

  function setState(state) {
    wrap.setAttribute('data-contact-state', state);
    wrap.querySelectorAll('[data-state-input]').forEach((el) => {
      el.hidden = state !== 'input';
    });
    wrap.querySelectorAll('[data-state-confirm]').forEach((el) => {
      el.hidden = state !== 'confirm';
    });
    updateBreadcrumb(state === 'confirm' ? BREADCRUMB_CONFIRM : BREADCRUMB_BASE);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function updateBreadcrumb(text) {
    const current = document.querySelector('.breadcrumb__item--current span');
    if (current) current.textContent = text;
  }

  function clearErrors(field) {
    const row = field.closest('.nj-contact__row');
    const container = row.querySelector('[data-errors-for]');
    row.classList.remove('is-invalid');
    if (container) {
      container.innerHTML = '';
      container.hidden = true;
    }
  }

  function showErrors(field, messages) {
    const row = field.closest('.nj-contact__row');
    const container = row.querySelector('[data-errors-for]');
    row.classList.add('is-invalid');
    if (container) {
      container.hidden = false;
      container.innerHTML = messages
        .map((m) => `<p class="nj-contact__error-text">${m}</p>`)
        .join('');
    }
  }

  function validateField(field) {
    const rules = (field.dataset.validate || '').split(/\s+/).filter(Boolean);
    const value = field.value.trim();
    const errors = [];

    if (rules.includes('required') && value === '') {
      errors.push('※必須項目です');
    }
    if (rules.includes('email') && value !== '' && !EMAIL_RE.test(value)) {
      errors.push('※メールアドレスが正しくありません');
    }
    if (rules.includes('match-email') && value !== '') {
      const target = document.querySelector(field.dataset.matchTarget);
      if (target && target.value.trim() !== value) {
        errors.push('※メールアドレスが一致しません');
      }
    }

    if (errors.length) {
      showErrors(field, errors);
      return false;
    }
    clearErrors(field);
    return true;
  }

  function validateAll() {
    let ok = true;
    fields.forEach((f) => {
      if (!validateField(f)) ok = false;
    });
    return ok;
  }

  function renderPreviews() {
    fields.forEach((field) => {
      const row = field.closest('.nj-contact__row');
      const preview = row.querySelector('[data-preview-for]');
      if (preview) preview.textContent = field.value;
    });
  }

  wrap.querySelectorAll('[data-action="confirm"]').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (!validateAll()) {
        const firstInvalid = wrap.querySelector('.is-invalid .nj-contact__input');
        if (firstInvalid) firstInvalid.focus();
        return;
      }
      renderPreviews();
      setState('confirm');
    });
  });

  wrap.querySelectorAll('[data-action="back"]').forEach((btn) => {
    btn.addEventListener('click', () => {
      setState('input');
    });
  });

  fields.forEach((field) => {
    field.addEventListener('blur', () => validateField(field));
    field.addEventListener('input', () => {
      if (field.closest('.nj-contact__row').classList.contains('is-invalid')) {
        validateField(field);
      }
    });
  });

  // 送信直前: Shopify Flow 自動返信用の note を整形して注入
  form.addEventListener('submit', () => {
    const noteField = form.querySelector('[data-contact-note]');
    if (!noteField) return;
    const get = (id) => {
      const el = document.getElementById(id);
      return el ? el.value.trim() : '';
    };
    noteField.value = [
      '■お名前: ' + get('ContactForm-name'),
      '■ご連絡先: ' + get('ContactForm-phone'),
      '■メールアドレス: ' + get('ContactForm-email'),
      '■お問い合わせ内容:',
      get('ContactForm-body'),
    ].join('\n');
  });
})();
